
import React, { useState, useEffect } from 'react';

const TestimonialSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const testimonials = [
    {
      quote: "The AI system transformed our lead generation completely. We're booking 3x more qualified prospects with zero manual effort.",
      name: "Sarah Chen",
      title: "CEO, HealthFirst Wellness",
      avatar: 'https://public.readdy.ai/ai/img_res/ec39aa9c7fa533d28e26ac7289f29e64.jpg'
    },
    {
      quote: "Process automation saved us 20 hours per week. Our team can now focus on what matters most to our clients.",
      name: "Michael Rodriguez",
      title: "Operations Director, Elite Services",
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20businessman%20operations%20director%20headshot%2C%20clean%20white%20background%2C%20confident%20expression%2C%20modern%20business%20suit%2C%20minimalist%20corporate%20photography%20style%2C%20Apple-inspired%20aesthetic&width=100&height=100&seq=michael-apple&orientation=squarish'
    },
    {
      quote: "Client retention increased by 40% after implementation. The automated follow-ups are incredibly effective.",
      name: "Jennifer Park",
      title: "Founder, Park Financial",
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20businesswoman%20founder%20headshot%2C%20clean%20white%20background%2C%20warm%20smile%2C%20modern%20professional%20attire%2C%20minimalist%20portrait%20style%2C%20Apple-inspired%20aesthetic&width=100&height=100&seq=jennifer-apple&orientation=squarish'
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  return (
    <section className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-20">
          <h3 className="text-4xl md:text-5xl font-light text-black mb-6 tracking-tight">
            What our clients say
          </h3>
        </div>
        
        <div className="relative">
          <div className="bg-gray-50 rounded-3xl p-12">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-8 rounded-full overflow-hidden">
                <img
                  src={testimonials[currentSlide].avatar}
                  alt={testimonials[currentSlide].name}
                  className="w-full h-full object-cover"
                />
              </div>
              
              <blockquote className="text-2xl md:text-3xl text-gray-900 font-light leading-relaxed mb-8 tracking-tight">
                "{testimonials[currentSlide].quote}"
              </blockquote>
              
              <div>
                <div className="text-lg font-medium text-black">
                  {testimonials[currentSlide].name}
                </div>
                <div className="text-base text-gray-600 font-light">
                  {testimonials[currentSlide].title}
                </div>
              </div>
            </div>
          </div>
          
          {/* Slide indicators */}
          <div className="flex justify-center space-x-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                  currentSlide === index ? 'bg-black' : 'bg-gray-300'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
